import { render, staticRenderFns } from "./lecturers.vue?vue&type=template&id=7708a593&scoped=true&"
import script from "./lecturers.vue?vue&type=script&lang=js&"
export * from "./lecturers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7708a593",
  null
  
)

export default component.exports